<template>
  <div>
    <opq-basic-appbar>
      <template v-if="ressources.length > 0">
        <ressource code="titre-formulaire"></ressource>
      </template>
      <template v-else>
        <v-skeleton-loader type="text" width="250" height="15"></v-skeleton-loader>
      </template>
    </opq-basic-appbar>
    <v-main>
      <v-sheet class="ml-6 py-4 py-md-8 py-lg-12 px-2 px-md-6 px-lg-12">
        <template v-if="loading || loadingInfos">
          <opq-loading />
        </template>
        <template v-else>
          <div class="text-center my-12">

            <ressource code="message-consentement-illuxi" class="mb-3"></ressource>

            <div class="mt-6">
              <v-btn class="ma-6" x-large dark color="#3a3838" @click="submitYes">
                {{ getRessource("btn-opt-in") }}
              </v-btn>
              <v-btn class="ma-6" x-large dark color="#3a3838" @click="submitNo">
                {{ getRessource("btn-opt-out") }}
              </v-btn>
            </div>

          </div>
        </template>
      </v-sheet>
    </v-main>
  </div>
</template>

<script>

import { mapGetters } from "vuex"
import FormulaireBase from "@/mixins/FormulaireBase"
import RessourcesHelpers from "@/mixins/RessourcesHelpers"
import { Api } from "@/plugins/api"

export default {
  mixins: [FormulaireBase, RessourcesHelpers],
  data() {
    return {
      paramsName: "redirection-illuxi",
      hasConsentement: false,
      loadingInfos: true
    }
  },
  created() {
      this.loadingInfos = true
      this.loadParams(this.paramsName)
      Api.get("/sso/illuxi/has-consentement?token=" + this.encodedToken)
        .then((res) => {
          this.hasConsentement = res.data
          if (this.hasConsentement) {
            this.redirectToIlluxi() 
          }
          else {
            // affichage message + boutons
            this.loadingInfos = false
          }
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push({
              name: "NotFound",
            })
          } else if (error.response.status === 401) {
            this.$router.push({
              name: "Unauthorized",
            })
          } else {
            this.$router.push({
              name: "InternalError",
            })
          }
        })
    },
   methods: {    
    createConsentement(statut) {
      return Api.get("/sso/illuxi/create-consentement?token=" + this.encodedToken + "&statut=" + statut)
        .then((res) => {
          return res.data
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push({
              name: "NotFound",
            })
          } else if (error.response.status === 401) {
            this.$router.push({
              name: "Unauthorized",
            })
          } else {
            this.$router.push({
              name: "InternalError",
            })
          }
        })
    },
    redirectToIlluxi() {
      Api.get("/sso/illuxi/redirect-url?token=" + this.encodedToken + "&redirect=" + this.redirectType)
        .then((res) => {
          if (res.data && res.data != '') {
            window.location.href = res.data
          }
          else {
            this.$router.push({
              name: "InternalError",
            })
          }
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push({
              name: "NotFound",
            })
          } else if (error.response.status === 401) {
            this.$router.push({
              name: "Unauthorized",
            })
          } else {
            this.$router.push({
              name: "InternalError",
            })
          }
        })
    },
    redirectToPortail() {
      window.location.href = this.urlPortail
    },
    submitYes() {
      this.createConsentement("in")
        .then((res) => {
          if (res){
            this.redirectToIlluxi()
          } else {
            this.$router.push({
                name: "InternalError",
              })
          }
        })
    },
    submitNo() {
      this.createConsentement("out")
        .then((res) => {          
          if (res) {
            this.redirectToPortail()
          }
          else {
            this.$router.push({
                name: "InternalError",
              })
          }
        })
    }
   },
  computed: {
    ...mapGetters(["ressources"]),
    encodedToken() {
      const token = this.$route.query.token.replace(/\s/g, "+")
      return encodeURIComponent(token)
    },
    redirectType() {    
      return this.$route.query.redirect
    },
    urlPortail() {
      return process.env.VUE_APP_URL_PORTAIL
    }
  },
}
</script>

<style>
</style>